/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var symphony = window.symphony || {};

symphony.config = {
	latLong: [],
	zip: undefined,
	updateResults: false,
	utilities: {
		modal: {},
		expandingHeader: $('.js-doesExpand')
	}
}

symphony.site = {
	common: {
		init: function () {
			//symphony.crossStorage();
			//symphony.alertsDisplay();
			symphony.checkHeroExistence();
			symphony.defaultModal();
			symphony.detectFeatures();
			symphony.donateHeaderActions();
			//symphony.donationsModal();
			//symphony.fitVids();
			symphony.geolocate();
			symphony.getHelpHeader();
			symphony.givingToolbar();
			symphony.handlebarsHelpers();
			symphony.parseEvents();
			symphony.scrollToNextSection();
			symphony.showOnHover();
			symphony.stickyFooter();
			//symphony.stickyNav();
			symphony.thumbnailSlider();
			symphony.toggleMenu();

			// Row modules
			symphony.rowDonate();

			symphony.utagEvents();
			symphony.browserDetect();
			symphony.registerEvents();

			symphony.initCarousel();
			symphony.heroSlider();
		}
	},
	home: {
		init: function () {
			symphony.videoModal();
			symphony.gmapPopulation();
		}
	},
	get_help: {
		init: function () {
			bridgesWrapper.init();
		}
	},
	stories: {
		init: function () {
			// applies to THQ Master site "stories" page
			symphony.getCaringStories();
		}
	},
	story: {
		init: function () {
			// applies to local site "allstories" dynamic view
			symphony.getLocalStories();
		}
	},
	newsroom: {
		init: function () {
			// applies to local site "allstories" dynamic view
			symphony.getLocalStories();
		}
	},
	ministry: {
		init: function () {
			if (symphony != null && symphony.getLocalStories != null && typeof symphony.getLocalStories == "function") {
				symphony.getLocalStories();
			}
		}
	},
	waystogive: {
		init: function () {
			$("#grid-fixed").mason({
				itemSelector: '.givingGrid-item',
				ratio: 1.5,
				sizes: [
					[1, 2],
					[2, 1],
					[2, 2]
				],
				columns: [
					[0, 480, 1],
					[480, 780, 2],
					[780, 1080, 3],
					[1080, 3200, 4]
				],
				filler: {
					itemSelector: '.givingGrid-filler',
					filler_class: 'mason_filler'
				},
				gutter: 12,
				layout: 'fluid'
			});
		}
	},
	press_releases: {
		init: function () {
			symphony.pressReleaseGrid();
		}
	},
	news: {
		init: function () {
			symphony.getLocalNews();
		}
	},
	landingpage: {
		init: function () {
			if ($('.existingContent').length > 0) {
				$('iframe[height="200"]').each(function () {
					$(this).width('100%');
					$(this).height($(this).width() / 16 * 9).css({
						'min-height': 200,
						'max-height': 500
					});
				});
			}
		}
	},
	contact_us: {
		init: function () {
			symphony.getWufooScript();

			$('form.wufoo').on('submit', function (e) {
				utag.link({
					'event_name': 'Send Email', //Event Name
					'link_text': 'Submit', //Link Text
					'page_name': 'SAL:' + utagSite + ' | contact us form:complete', //Page Name
					'site_section': 'Contact', //Site Section
					'site_type': 'SAL:' + utagSite, //Site Type
					'login_status': 'Not Logged In', //Login Status
					'event_type': 'contact_form_submit', //Event Type
				});
			});

		}
	},
	search_results: {
		init: function () {
			var slides = $('.impactStories-slide');
			slides.has('a[href*="style_guide"]').css('display', 'none');
			slides.has('a[href*="references"]').css('display', 'none');
		}
	},
	location_search: {
		init: function () {
			// load a default/sticky header with no need for hero image

			function paramReplace(name, string, value) {
				// Find the param with regex
				// Grab the first character in the returned string (should be ? or &)
				// Replace our href string with our new value, passing on the name and delimeter

				var re = new RegExp("[\\?&]" + name + "=([^&#]*)");
				var matches = re.exec(string);
				var newString;

				if (matches === null) {
					// if there are no params, append the parameter
					newString = string + '?' + name + '=' + value;
				} else {
					var delimeter = matches[0].charAt(0);
					newString = string.replace(re, delimeter + name + "=" + value);
				}
				return newString;
			}

			function getZip(city) {
				$.get('//maps.googleapis.com/maps/api/geocode/json?address=' + city + '&sensor=true', function (response) {
					if (response.results.length > 0) {
						gdosWrapper.config.latLong = [response.results[0].geometry.location.lat, response.results[0].geometry.location.lng];
						console.log(gdosWrapper.config.latLong);
						gdosWrapper.getCenters(gdosWrapper.config.latLong[0], gdosWrapper.config.latLong[1]).done(function (data) {

							gdosWrapper.config.gdosResults = gdosWrapper.parseResults(data.objects);

							gdosWrapper.storeResults(JSON.stringify(gdosWrapper.config.gdosResults));

							// display results in handlebars template
							gdosWrapper.config.resultsContainer.empty().append(symphony.templates.gdosResults(gdosWrapper.groupResults(gdosWrapper.config.gdosResults)));

							gdosWrapper.createMap(gdosWrapper.config.gdosResults, '#map');

						});
					}
				});
			}

			$('.js-gdosSearch').on('click', function (e) {
				var inputVal = $(this).parent().find('#zip').val();
				var reg = new RegExp('^[0-9]+$');
				if (!reg.test(inputVal)) {
					getZip(inputVal);
				}
				return;

				//localStorage.setItem("zip", inputVal);
				//localStorage.getItem("zip", inputVal);

				// var obj = { Title: 'Location Search Results for ' + inputVal, Url: paramReplace('location','', inputVal)};
				// history.pushState(obj, obj.Title, obj.Url);
				// getNewResults();
			});

			if (window.localStorage && localStorage.getItem('zip') !== null) {
				$('.section').find('#zip').val(JSON.parse(localStorage.getItem('zip')));
			}

			symphony.config.zip = symphony.getURLParam('location');

			if (symphony === undefined || symphony.config.zip === undefined) {
				var map = new GMaps({
					el: "#map",
					zoom: 5,
					lat: '39.291797',
					lng: '-118.476563',
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					draggable: true
				});
			} else {
				$('.section').find('#zip').val(symphony.config.zip);
			}

			gdosWrapper.config.zip = symphony.config.zip;
			$('#zip').val(symphony.config.zip);

			// Do we already have stored results?
			if (gdosWrapper.validateData(localStorage.getItem("gdosResults"))) {

				getSavedResults();

			} else {

				getNewResults();

			}

			window.onpopstate = function () {
				getNewResults();
			};

			function getSavedResults() {
				if (symphony.config.updateResults === true) {
					getNewResults();
				}

				gdosWrapper.config.gdosResults = gdosWrapper.parseResults(localStorage.getItem("gdosResults"));
				var utag_data_ls = {
					page_name: 'SAL:' + utagSite + ' | location search results',
					site_section: 'Search',
					site_type: 'SAL:' + utagSite,
					loc_search_term: symphony.config.zip.toString(),
					loc_search_results: gdosWrapper.config.gdosResults.length.toString(),
					login_status: 'Not Logged In',
					event_type: 'loc_search'
				};
				if (typeof utag != "undefined") {
					utag.view(utag_data_ls);
				} else {
					var utag_data = utag_data_ls;
				}

				gdosWrapper.config.resultsContainer.empty().append(symphony.templates.gdosResults(gdosWrapper.groupResults(gdosWrapper.config.gdosResults)));

				gdosWrapper.createMap(gdosWrapper.config.gdosResults, '#map');
			}

			function getNewResults() {

				localStorage.removeItem('gdosResults');

				var location = symphony.getURLParam('location');

				if (location == undefined) return;

				gdosWrapper.getLatLong(location).done(function (data) {

					gdosWrapper.config.latLong = [data.latitude, data.longitude];

					gdosWrapper.getCenters(gdosWrapper.config.latLong[0], gdosWrapper.config.latLong[1]).done(function (data) {

						gdosWrapper.config.gdosResults = gdosWrapper.parseResults(data.objects);
						var utag_data_ls = {
							page_name: 'SAL:' + utagSite + ' | location search results',
							site_section: 'Search',
							site_type: 'SAL:' + utagSite,
							loc_search_term: symphony.config.zip.toString(),
							loc_search_results: gdosWrapper.config.gdosResults.length.toString(),
							login_status: 'Not Logged In',
							event_type: 'loc_search'
						};
						if (typeof utag != "undefined") {
							utag.view(utag_data_ls);
						} else {
							var utag_data = utag_data_ls;
						}

						gdosWrapper.storeResults(JSON.stringify(gdosWrapper.config.gdosResults));

						// display results in handlebars template
						gdosWrapper.config.resultsContainer.empty().append(symphony.templates.gdosResults(gdosWrapper.groupResults(gdosWrapper.config.gdosResults)));

						gdosWrapper.createMap(gdosWrapper.config.gdosResults, '#map');

					});
				});
			}

			// filter results by corps, stores, arc centers, service centers, senior residences, drop off locations

			// add returned categories, "offerings" and "types" to select dropdowns for filtering

			// enable results updating by adding new zip to URL or updating in filter input box


		}
	},

	animateScrollTo: function ($elm, offset) {
		offset = offset || 0;
		var $container = $('html, body');
		if ($('.preview-container').length > 0) {
			$container = $('.preview-container');
		}
		$container.animate({
			scrollTop: $elm.offset().top - $('header').outerHeight() + offset
		}, 1000);
	}
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
	fire: function (func, funcname, args) {
		var namespace = symphony.site;
		funcname = (funcname === undefined) ? 'init' : funcname;
		if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
			namespace[func][funcname](args);
		}
	},
	loadEvents: function () {
		UTIL.fire('common');

		$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
			UTIL.fire(classnm);
		});
	},
	GetQueryStringParameterByName: function (name, url) {
		url = url || location.search;
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(url);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	},
	debounce: function (func, wait, immediate) {
		var timeout;

		return function executedFunction() {
			var context = this;
			var args = arguments;

			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};

			var callNow = immediate && !timeout;

			clearTimeout(timeout);

			timeout = setTimeout(later, wait);

			if (callNow) func.apply(context, args);
		};
	}
};

$(document).ready(UTIL.loadEvents);
